import { map, min } from 'lodash';

export default [ 'apiOrderService', 'configService', '$window', (apiOrderService, configService, $window) => {

  let order = {};
  order.contents = {
    'basket_identity_code': null,
    'customer': {},
    'customer_id': 0,
    'payment_status': '',
    'payment_token': null,
    'promo_details': '',
    'voucher_details': ''
  };

  order.generateOrder = basket_id => {
    return apiOrderService.generateOrder(basket_id)
      .then(response => {

        if (response.customer && order.contents.customer && !Object.keys(response.customer).length) {
          response.customer = order.contents.customer;
        }

        response.vouchers = response.vouchers && response.vouchers.length ? response.vouchers : [];
        order.contents = response;
        return order.contents;
      });
  };

  order.retrieveOrder = basket_id => {
    return apiOrderService.retrieveOrder(basket_id)
      .then(response => {
        order.contents = response;
      })
      .catch(() => {
      // Swallow error
      });
  };


  order.handleUpdateError = (error) => {
    order.contents.payment_status_id = 2; // token_error

    return order.handleOrderUpdates(error);
  };

  order.handleUpdateSuccess = (token, timestamp, card) => {
    order.contents.payment_status_id = 3; // token
    order.contents.payment_token = token;
    order.contents.payment_token_timestamp = timestamp;


    if (configService.get('gateways.stripe') && card) {
      order.contents.avs_country = card.country || null;
    }

    return order.handleOrderUpdates({ 'code': 'token', 'message': 'Payment token created.' });
  };

  order.handleOrderUpdates = (submitTransaction) => {
    return order.updateOrder(order.contents)
      .then(() => {
        if (submitTransaction) {
          order.submitTransaction(submitTransaction);
        }
      })
      .catch(() => {
        //
      });
  };

  order.updateOrder = () => {
    if (order.contents.vouchers && order.contents.vouchers.length) {
      order.contents.promo_details = null;
    }

    return apiOrderService.updateOrder(order.contents);
  };

  order.submitTransaction = transaction => {
    if (order.contents.basket_identity_code) {
      return apiOrderService.submitTransaction(order.contents.basket_identity_code, transaction)
        .catch(() => {
          //
        });
    }

    if ($window.Sentry) {
      $window.Sentry.withScope(scope => {
        scope.setExtra('transaction', transaction);
        $window.Sentry.captureMessage(`Fail submitting transaction, no order for basket: ${order.contents.basket_identity_code}`);
      });
    }

    return;
  };

  order.earliestOrder = () => {
    let dates = map(order.contents.item, (item) => {
      return `${item.date} ${item.preferred_time}`;
    });

    return min(dates);
  };

  order.invalidateToken = () => {
    order.contents.payment_token_timestamp = 0;
    order.contents.payment_token = null;
    order.contents.order_status_id = 1;
    return true;
  };

  return order;
} ];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/order/services/order.service.js